<template>
  <div class="vuetable-filterbar col-md-12">
    <div class="form-group p-l">
      <b-container fluid class="p-a-0">
        <b-row no-gutters>
          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="nf_ini"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nf Inicial</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="nf_fim"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Nf Final</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="num_carga"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N°Carga</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão NF Inicial"
              v-model="dt_nf_emi_ini"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão NF Final"
              v-model="dt_nf_emi_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="cte_ini"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CTE Inicial</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="cte_fim"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CTE Final</label
              >
            </div>
          </b-col>
          <!-- <b-col sm="6" md="1" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="serie"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Serie Cte</label
              >
            </div>
          </b-col> -->
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão CTE Inicial"
              v-model="dt_cte_emi_ini"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <b-form-datepicker
              locale="pt-br"
              reset-button
              placeholder="Emissão CTE Final"
              v-model="dt_cte_emi_fim"
              class="form-control"
              :date-format-options="{
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
              }"
            >
            </b-form-datepicker>
          </b-col>
          <b-col sm="6" md="3" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="cnpj_origem"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >CNPJ emissor da NF</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="mdfe"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >N° Manifesto</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="chave"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >Chave de acesso NFe</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="3" class="m-t-5px p-a-0">
            <div class="fl-flex-label fl-collapsed fl-background">
              <input
                type="text"
                class="form-control"
                v-model="email_usuario_inc"
                @keyup.enter="doFilter"
              />
              <label
                class="fl-label"
                for="default-input"
                style="left: 13px; right: 12px"
                >E-mail usuário inclusão da NF</label
              >
            </div>
          </b-col>
          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="unidade_parceira"
              :options="this.$parent.optionsPessoaParceira"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Unidade Parceira"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="5" class="p-a-0 m-t-5px">
            <multiselect
              v-model="redespacho"
              :options-limit="300"
              :limit="2"
              :limit-text="limitText"
              :options="optionsRedespacho"
              track-by="value"
              label="label"
              id="redespacho"
              :hide-selected="true"
              placeholder="Redespacho ( Digite 3 caracteres para pesquisar )"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              :searchable="true"
              :loading="isLoadingRedespacho"
              @search-change="listaRedespacho"
            ></multiselect>
          </b-col>

          <b-col sm="6" md="2" class="p-a-0 m-t-5px">
            <multiselect
              v-model="tp_processo_cte"
              :options="this.$parent.optionsTpProcesso"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Tipo Processo do CTE"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
            ></multiselect>
          </b-col>
          <b-col sm="6" md="3" class="m-t-5px">
            <div class="input-group-btn">
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="doFilter"
                  :disabled="vuetableFilterButton"
                >
                  Filtrar
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-outline"
                  @click="resetFilter"
                  :disabled="vuetableFilterButton"
                >
                  Limpar
                </button>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { formatCNPJFromParts } from "../utils";

export default {
  data() {
    return {
      nf_ini: "",
      nf_fim: "",
      dt_nf_emi_ini: "",
      dt_nf_emi_fim: "",
      cte_ini: "",
      cte_fim: "",
      serie: "",
      dt_cte_emi_ini: "",
      num_carga: "",
      dt_cte_emi_fim: "",
      cnpj_origem: "",
      mdfe: "",
      chave: "",
      email_usuario_inc: "",
      status_importacao: "",
      unidade_parceira: "",
      tp_processo_cte: "",
      status: [],
      tp_pessoa: [],
      municipio: [],
      redespacho: [],
      data_filter: [],
      isLoadingRedespacho: false,
      optionsRedespacho: [],
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
    };
  },

  methods: {
    doFilter() {
      this.$store.commit("setVuetableFilterButton", true);
      this.data_filter = {
        nf_ini: this.nf_ini,
        nf_fim: this.nf_fim,
        dt_nf_emi_ini: this.dt_nf_emi_ini,
        dt_nf_emi_fim: this.dt_nf_emi_fim,
        num_carga: this.num_carga,
        cte_ini: this.cte_ini,
        cte_fim: this.cte_fim,
        dt_cte_emi_ini: this.dt_cte_emi_ini,
        dt_cte_emi_fim: this.dt_cte_emi_fim,
        cnpj_origem: this.cnpj_origem,
        mdfe: this.mdfe,
        chave: this.chave,
        email_usuario_inc: this.email_usuario_inc,
        redespacho: this.redespacho,
        unidade_parceira: this.unidade_parceira,
        tp_processo_cte: this.tp_processo_cte,
      };
      this.$events.fire("filter-set", this.data_filter);
    },
    resetFilter() {
      this.nf_ini = "";
      this.nf_fim = "";
      this.dt_nf_emi_ini = "";
      this.dt_nf_emi_fim = "";
      this.cte_ini = "";
      this.cte_fim = "";
      this.num_carga = "";
      this.dt_cte_emi_ini = "";
      this.dt_cte_emi_fim = "";
      this.cnpj_origem = "";
      this.mdfe = "";
      this.chave = "";
      this.email_usuario_inc = "";
      this.redespacho = "";
      this.unidade_parceira = "";
      this.tp_processo_cte = "";
      this.$events.fire("filter-reset");
    },
    listaRedespacho(search) {
      if (search.length >= 3) {
        this.isLoadingRedespacho = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/fornecedor")
          .then((response) => {
            this.optionsRedespacho = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsRedespacho.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsRedespacho.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsRedespacho.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingRedespacho = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
        onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
    },
  },
  computed: {
    vuetableFilterButton: {
      get() {
        return this.$store.state.vuetable.filterButton;
      },
    },
  },
};
</script>